import { render, staticRenderFns } from "./third.vue?vue&type=template&id=3b023c4a&scoped=true&"
import script from "./third.vue?vue&type=script&lang=js&"
export * from "./third.vue?vue&type=script&lang=js&"
import style0 from "./third.vue?vue&type=style&index=0&id=3b023c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b023c4a",
  null
  
)

export default component.exports